// 108 / PI
const R2D = 57.2957795131;

/**
 * @param {*} dx delta x
 * @param {*} dy delta y
 * @return {string} bearing rounded to degrees (no minutes, secconds, etc.)
 */
export default function bearing(dx, dy) {
  let bearing;
  let angle = Math.round(Math.atan(dy / dx) * R2D);

  if (dx > 0 && dy > 0) {         // NE
    bearing = 'N' + (90 - angle) + 'E ';
  } else if (dx < 0 && dy > 0) {  // NW
    bearing = 'N' + (90 + angle) + 'W ';
  } else if (dx < 0 && dy < 0) {  // SW
    bearing = 'S' + (90 - angle) + 'W ';
  } else {
    bearing = 'S' + (90 + angle) + 'E ';
  }
  return bearing;
}

/*
// below uses atan2(X,Y) which requires a polyfil for IE
// it also uses a non-standard parameter order for atan2

function bearing2(dx, dy) {
  let bearing;
  // atan2 documentation all lists Y,X but using X,Y below, which seems to work fine
  let angle = (Math.atan2(dx, dy) * R2D);
  angle = Math.round(angle)
  if (angle < 0) {
    if (angle < -90) {
      bearing = 'S' + (angle + 180) + 'W ';
    } else {
      bearing = 'N' + Math.abs(angle) + 'W ';
    }
  } else {
    if (angle > 90) {
      bearing = 'S' + (180 - angle) + 'E ';
    } else {
      bearing = 'N' + (angle) + 'E ';
    }
  }
  return bearing;
}
*/
